<template>
    <button @click="handleRoeIdLogin" type="button" class="roeid-button-wrapper mb-5">
        <div id="roeid-placeholder" class="roeid-container roeid-button-size-l ex1">
            <div class="roeid-left">
                <img src="https://api.roeid.ro/public/img/roeid_logo_secondary.svg" alt="ROeID" width="38" height="38" />
            </div>
            <div class="roeid-middle">{{ buttonText }}</div>
        </div>
    </button>

</template>
<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'RoeIdLoginButton',
        components: {
        },
        props: {
            formType: {
                type: String,
                required: true
            },
            isPopUpEnabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                emailNotReceivedMessage: this.$t('ERRORS.FACEBOOK_EMAIL_NOT_RECEIVED'),
                invalidAuthMessage: this.$t('ERRORS.AUTH_INVALID'),
            };
        },
        computed: {
            apiUrl() {
                return process.env.VUE_APP_API_URL || window.VUE_APP_API_URL;
            },
            buttonText() {
                return this.formType === 'register'
                    ? this.$t('AUTH.REGISTER.ROEID_BUTTON')
                    : this.$t('AUTH.LOGIN.ROEID_BUTTON');
            },
            loginUrl() {
                return `${this.apiUrl}/auth/pscid/login`;
            }
        },
        methods: {
            ...mapActions({
                getRoeIdAuth: 'auth/getRoeIdAuth',
            }),
            async handleRoeIdLogin() {
                const response = await this.getRoeIdAuth();
                if (response?.data && response.data.url) {
                    window.location.href = response.data.url;
                    return;
                }
            },
        },
    };
</script>
<style scoped>
    .roeid-button-wrapper {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        width: 100%;
        text-align: left;
    }

    .ex1 {
        width: 100%;
    }

    /* Owned here instead of loading roeidinclude.css, whose global svg rule restyles every icon in the app. */
    .roeid-container {
        display: table;
        height: 100%;
        font-family: "Sora", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
        background-color: #2e5ae6;
        color: #fff;
        cursor: pointer;
        user-select: none;
        border-radius: 0.5em;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .roeid-left {
        display: table-cell;
        padding: 0.5em 0 0.2em 0.5em;
    }

    .roeid-middle {
        display: table-cell;
        padding: 0 0.5em;
        vertical-align: middle;
        text-align: center;
    }

    .roeid-button-size-l {
        font-size: 20px;
        border-radius: 1rem;
    }

    .roeid-button-size-l > div img {
        display: inline-block;
        width: 38px;
        height: 38px;
        border: 0;
    }
</style>
